  const items = document.querySelectorAll('.scroll-animate');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    },
    { threshold: 0.2 }
  );

  items.forEach(item => observer.observe(item));




  gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {

    // Fade Up
    gsap.utils.toArray(".reveal-up").forEach(el => {

        gsap.from(el,{
            opacity:0,
            y:70,
            duration:1,
            ease:"power4.out",

            scrollTrigger:{
                trigger:el,
                start:"top 88%",
                once:true
            }

        });

    });



    // Fade Left
    gsap.utils.toArray(".reveal-left").forEach(el => {

        gsap.from(el,{
            opacity:0,
            x:-80,
            duration:1,
            ease:"power4.out",

            scrollTrigger:{
                trigger:el,
                start:"top 88%",
                once:true
            }

        });

    });



    // Fade Right

    gsap.utils.toArray(".reveal-right").forEach(el => {

        gsap.from(el,{
            opacity:0,
            x:80,
            duration:1,
            ease:"power4.out",

            scrollTrigger:{
                trigger:el,
                start:"top 88%",
                once:true
            }

        });

    });



    // Scale

    gsap.utils.toArray(".reveal-scale").forEach(el => {

        gsap.from(el,{
            opacity:0,
            scale:.88,
            duration:1.2,
            ease:"expo.out",

            scrollTrigger:{
                trigger:el,
                start:"top 88%",
                once:true
            }

        });

    });



    // Stagger

    gsap.utils.toArray(".stagger-parent").forEach(parent=>{

        gsap.from(parent.querySelectorAll(".stagger-item"),{

            opacity:0,
            y:40,
            duration:.8,
            stagger:.12,
            ease:"power3.out",

            scrollTrigger:{
                trigger:parent,
                start:"top 88%",
                once:true
            }

        });

    });

});